import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IProiectAddPayload } from './proiecte.interface';
import { catchError, map, throwError } from 'rxjs';
import { EditProiectStatusPayload } from './detalii-proiecte/actualizare-proiect/actualizare-proiect.interface';

@Injectable({
    providedIn: 'root'
})
export class ProiecteService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listProiecteURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listProiecte;
    private listDTProiecteURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listDTProiecte;
    private listOperatoriURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listOperatori;
    private listActiveDepartamenteURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listActiveDepartamente;
    private listResponsabiliURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listResponsabili;
    private addProiectURL =
        this.basePath +
        environment.interop.monitoring.proiecte.storeProiect;
    private getProiectURL =
        this.basePath +
        environment.interop.monitoring.proiecte.viewProiect;

    private fileUploadUrl =
        this.basePath + environment.interop.monitoring.file.fileUpload;
    private fileUploadBase64Url =
        this.basePath + environment.interop.monitoring.file.fileUploadBase64;

    private postMessageUrl =
        this.basePath + environment.interop.monitoring.proiecte.sendMesaj;
    private istoricMesajeURL =
        this.basePath + environment.interop.monitoring.proiecte.istoricMesaje;

    private updateTermeneURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateTermene;
    private getResposabiliURL =
        this.basePath +
        environment.interop.monitoring.proiecte.listResponsabiliByDirectie;
    private addResponsabilURL =
        this.basePath +
        environment.interop.monitoring.proiecte.addResponsabil;
    private removeResponsabilURL =
        this.basePath +
        environment.interop.monitoring.proiecte.removeResponsabil;
    private setPrimaryResponsabilURL =
        this.basePath +
        environment.interop.monitoring.proiecte.primaryResponsabil;
    private addOperatorURL =
        this.basePath +
        environment.interop.monitoring.proiecte.addOperator;
    private removeOperatorURL =
        this.basePath +
        environment.interop.monitoring.proiecte.removeOperator;
    private setPrimaryOperatorURL =
        this.basePath +
        environment.interop.monitoring.proiecte.primaryOperator;

    private updateStatusUrl =
        this.basePath + environment.interop.monitoring.proiecte.actualizareStatus;

    private getActiveUsersUrl =
        this.basePath + environment.interop.monitoring.proiecte.user.getUsersList;
    private updateSubjectURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateSubject;
    private updateFurnizorURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateProvider;
    private updateTagURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateTag;
    private updateCategorieURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateCategorie;
    private updateCompartimentURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateCompartiment;

    private inchidereProiectURL =
        this.basePath +
        environment.interop.monitoring.proiecte.closeProiect;
    private anulareProiectURL =
        this.basePath +
        environment.interop.monitoring.proiecte.cancelProiect;
    private updateGarantieURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateGarantie;
    private uploadGarantieFilesURL =
        this.basePath +
        environment.interop.monitoring.proiecte.uploadGarantieFiles;
    public downloadDocumentURL =
        this.basePath +
        environment.interop.monitoring.proiecte.downloadDocument;
    private updateAdresaURL =
        this.basePath +
        environment.interop.monitoring.proiecte.updateAdresa;

    constructor(private http: HttpClient) { }

    getUsers() {
        return this.http.get(this.getActiveUsersUrl, this.httpOptions);
    }

    listProiecte() {
        return this.http.get(this.listProiecteURL);
    }

    listDTProiecte() {
        return this.http.post(this.listDTProiecteURL, {});
    }

    getActiveDepartamente() {
        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.listActiveDepartamenteURL)
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get departamente active:', error);
                    return throwError(error);
                })
            );
    }

    getOperatori() {
        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.listOperatoriURL)
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_user,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get operatori teren:', error);
                    return throwError(error);
                })
            );
    }

    getResponsabili() {
        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.listResponsabiliURL)
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_user,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get responsabili:', error);
                    return throwError(error);
                })
            );
    }

    addProiect(data: any) {
        return this.http.post(this.addProiectURL, data);
    }

    getProiect(id: number) {
        return this.http.get(this.getProiectURL + id);
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    updateTermene(id: number, data: any) {
        return this.http.put(this.updateTermeneURL + id, data);
    }

    updateProiectStatus(proiectId: number, status: EditProiectStatusPayload) {
        return this.http.put(this.updateStatusUrl + proiectId, status, this.httpOptions)
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageUrl + id, message, this.httpOptions);
    }
    istoricMesaje(id: number, type?: number) {
        return this.http.get(this.istoricMesajeURL + id + `?automated=${type ? type : -1}`);
    }

    getResponsabiliByDirectie(id_directie?: number, id_compartiment?: number) {
        if (!id_directie) id_directie = -1;
        if (!id_compartiment) id_compartiment = -1;

        return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(this.getResposabiliURL + id_directie + '/' + id_compartiment)
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_user,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get operatori teren:', error);
                    return throwError(error);
                })
            );
    }
    addResponsabil(id: number, data: { id_user: number }) {
        return this.http.post(this.addResponsabilURL + id, data);
    }
    removeResponsabil(id_record: number) {
        return this.http.get(this.removeResponsabilURL + id_record);
    }
    setPrimaryResponsabil(id_record: number) {
        return this.http.get(this.setPrimaryResponsabilURL + id_record);
    }
    addOperator(id: number, data: { id_user: number }) {
        return this.http.post(this.addOperatorURL + id, data);
    }
    removeOperator(id_record: number) {
        return this.http.get(this.removeOperatorURL + id_record);
    }
    setPrimaryOperator(id_record: number) {
        return this.http.get(this.setPrimaryOperatorURL + id_record);
    }

    updateSubject(id: number, data: any) {
        return this.http.post(this.updateSubjectURL + id, data);
    }
    updateFurnizor(id: number, data: any) {
        return this.http.post(this.updateFurnizorURL + id, data);
    }
    updateTag(id: number, data: any) {
        return this.http.post(this.updateTagURL + id, data);
    }
    updateCategorie(id: number, data: any) {
        return this.http.post(this.updateCategorieURL + id, data);
    }
    updateCompartiment(id: number, data: any) {
        return this.http.post(this.updateCompartimentURL + id, data);
    }

    inchidereProiect(id: number, data: any) {
        return this.http.post(this.inchidereProiectURL + id, data);
    }
    anulareProiect(id: number, data: any) {
        return this.http.post(this.anulareProiectURL + id, data);
    }
    updateGarantie(id: number, data: any) {
        return this.http.post(this.updateGarantieURL + id, data);
    }
    uploadGarantieFiles(id: number, data: any) {
        return this.http.post(this.uploadGarantieFilesURL + id, data);
    }
    updateAdresa(id: number, data: any) {
        return this.http.put(this.updateAdresaURL + id, data);
    }


    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
